module.exports = __webpack_public_path__ + "img/auth.55a4e0e8.png";